import React, { useState, useEffect, MouseEvent } from 'react';
import {
  AppBar,
  Box,
  Toolbar,
  IconButton,
  Typography,
  Popover,
  Container,Button,
  MenuItem,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import AppButton from '../button';
import { useLocation, Link } from 'react-router-dom';
// import LogoImg from '../../../assets/clinical-visuals-logo-white.png'

const VISUALIZE__URL = import.meta.env.VITE_VISUALIZE__URL;
const LogoImg = VISUALIZE__URL + "Clinical_Visuals_Logo.webp";
interface HeaderProps {
  className?: string;
}

const pages = ['Services', 'Blog', 'About Us', 'Contact Us', 'Start Project'];


const Header: React.FC<HeaderProps> = ({ className }) => {

  const location = useLocation();
  const [anchorElNav, setAnchorElNav] = useState<null | HTMLElement>(null);

  const [backgroundColor, setBackgroundColor] = useState('transparent');

  const handleOpenNavMenu = (event: MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const navLinks = [
    { name: 'Services', path: '/services' },
    { name: 'Blog', path: '/blog' },
    { name: 'About Us', path: '/about_us' },    
    { name: 'Contact Us', path: '/contact-us' },    
  ];

  const handleScroll = () => {
    const scrollY = window.scrollY;

    const screenHeight = window.innerHeight;

    const threshold = screenHeight * 0.2;

    const newColor = scrollY > threshold ? '#000000' : 'transparent';
    setBackgroundColor(newColor);
  };

  useEffect(() => {

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <AppBar
      className={`header ${className}`}
      sx={{
        backgroundColor: backgroundColor,
        transition: "background-color 0.5s ease",
        boxShadow: "none ",
      }}
    >
      <Container maxWidth={false}>
        <Toolbar disableGutters>
          <a href="/">
            <Box
              component="img"
              src={LogoImg}
              alt="Clinical Visuals"
              height={{ md: 200, xs: 150, sm: 150 }}
              width={{ md: 60, xs: 45, sm: 45 }}
              sx={{
                mr: 2,
                display: { xs: "none", md: "flex" },
                fontFamily: "monospace",
                fontWeight: 700,
                letterSpacing: ".3rem",
                color: "inherit",
                textDecoration: "none",
                // width: 200, // Set your desired width
                // height: 60, // Set your desired height
                "@media (max-width: 600px)": {
                  // width: 150, // Responsive width for smaller screens
                  // height: 45, // Responsive height for smaller screens
                },
              }}
            />
          </a>

          <Box
            component="img"
            src={LogoImg}
            alt="Clinical Visuals"
            height={{ md: 200, xs: 150, sm: 150 }}
            width={{ md: 60, xs: 45, sm: 45 }}
            sx={{
              mr: 2,
              display: { xs: "flex", md: "none" },
              fontFamily: "monospace",
              fontWeight: 700,
              letterSpacing: ".3rem",
              color: "inherit",
              textDecoration: "none",
              // width: 200, // Set your desired width
              // height: 60, // Set your desired height
              "@media (max-width: 600px)": {
                // width: 150, // Responsive width for smaller screens
                // height: 45, // Responsive height for smaller screens
              },
            }}
          />
          <Box
            sx={{
              flexGrow: 1,
              display: { xs: "flex", md: "none" },
              justifyContent: "flex-end",
            }}
          >
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Popover
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "center",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "center",
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: "block", md: "none" },
              }}
            >
              {pages.map((page) => (
                <MenuItem
                  key={page}
                  onClick={handleCloseNavMenu}
                  sx={{ width: "90vw", justifyContent: "center" }}
                >
                  <Typography textAlign="center" sx={{ width: "100%" }}>
                    <Link
                      to={`/${page.toLowerCase().replace(/\s+/g, "-")}`}
                      style={{
                        textDecoration: "none",
                        color: "inherit",
                        width: "100%",
                      }}
                    >
                      {page.toUpperCase()}
                    </Link>
                  </Typography>
                </MenuItem>
              ))}
            </Popover>
          </Box>

          <Box
            className="header_menu"
            sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}
          >
            {navLinks.map((link) => (
              <Button
                key={link.name}
                color="inherit"
                component={Link}
                to={link.path}
                className="nav_link"
              >
                {link.name}
              </Button>
            ))}
          </Box>

          <Box
            sx={{
              display: "flex",
              gap: "10px",
              "@media (minwidth: 600px)": { display: "none" },
            }}
          >
            {location.pathname !== "/start-project" && (
              <AppButton
                text="Start Project"
                sx={{
                  mr: 1,
                  backgroundColor: "#039ad1",
                  display: { xs: "none", md: "flex" },
                  fontFamily: "monospace",
                  color: "inherit",
                  textDecoration: "none",
                  textTransform: "capitalize",
                  letterSpacing: "2px",
                  border: "2px solid #fff",
                  borderRadius: "30px",
                  fontWeight: "500",
                }}
                onClick={() => {}}
                href="/start-project"
              />
            )}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}

export default Header;
